export enum DesignQualityType {
  BASIC = 'basic',
  HIGH = 'high',
}
